"use client"

import { useId } from "react"
import { useField } from "@payloadcms/ui"
import type { EmailFieldClientComponent } from "payload"

import { Input } from "@/components/ui/input"
import { FieldShell, resolveLabel } from "./field-shell"

/**
 * Shadcn-themed Payload Email field. Identical wiring to the text
 * field, just `type="email"` + `inputMode="email"` for mobile
 * keyboards. Validation comes from Payload's built-in email format
 * check; we don't double-validate client-side.
 */
export const ShadcnEmailField: EmailFieldClientComponent = (props) => {
  const { path, field } = props
  const fieldName = (field as { name?: string })?.name ?? path
  const { value, setValue, showError, errorMessage } = useField<string>({
    path: path ?? fieldName,
  })
  const id = useId()

  const label = resolveLabel(
    (field as { label?: unknown }).label,
    fieldName,
  )
  const description =
    (field as { admin?: { description?: unknown } })?.admin?.description
  const placeholder =
    ((field as { admin?: { placeholder?: unknown } })?.admin?.placeholder as
      | string
      | undefined) ?? "vous@adis95.fr"
  const required = Boolean((field as { required?: boolean }).required)

  return (
    <FieldShell
      label={label}
      required={required}
      description={
        typeof description === "string" || typeof description === "object"
          ? (description as React.ReactNode)
          : undefined
      }
      error={errorMessage}
      showError={showError}
      htmlFor={id}
    >
      <Input
        id={id}
        type="email"
        inputMode="email"
        autoComplete="email"
        value={typeof value === "string" ? value : ""}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-invalid={showError ? true : undefined}
        className="h-9 rounded-xl"
      />
    </FieldShell>
  )
}

export default ShadcnEmailField
